import { TimeAttackTeamTable } from "components/ResultTable/TimeAttack/TimeAttackTeamTable";
import { TimeAttackDriverTable } from "components/ResultTable/TimeAttack/TimeAttackDriverTable";
import { Panel } from "components/Panel/Panel";
import { TimeAttackSet } from "model/Match/Set/TimeAttack/TimeAttackSet";
import { MatchTeams } from "model/Match/MatchTeams";
import { MeatcTeamTable } from "components/ResultTable/TimeAttack/MeatcTeamTable";
import { SmsTimeAttackDriverTable } from "components/ResultTable/TimeAttack/SmsDriverTable";
import { SmsTimeAttackTeamTable } from "components/ResultTable/TimeAttack/SmsTeamTable";
import { BdlTeamTimeAttackTable } from "components/ResultTable/TimeAttack/BdlTeamTable";
import { BdlTimeAttackDriverTable } from "components/ResultTable/TimeAttack/BdlDriverTable";

interface Props {
  matchId: string;
  tournamentId: string;
  set: TimeAttackSet;
  teams: MatchTeams;
}

export const TimeAttackSetViewer = ({
  matchId,
  tournamentId,
  set,
  teams,
}: Props) => {
  /* todo - hardcoded */
  if (matchId === "1732942800000x001") {
    return <></>;
  }

  if (tournamentId === "Bdlx1") {
    return (
      <>
        <Panel>
          <BdlTeamTimeAttackTable
            set={set}
            teams={teams}
            tournamentId={tournamentId}
          />
        </Panel>
        <Panel>
          <BdlTimeAttackDriverTable
            set={set}
            teams={teams}
            tournamentId={tournamentId}
          />
        </Panel>
      </>
    );
  }

  if (matchId === "1725102000x001") {
    return (
      <Panel>
        <MeatcTeamTable set={set} teams={teams} tournamentId={tournamentId} />
      </Panel>
    );
  }

  if (matchId === "1739120400000x001") {
    return (
      <>
        {set.format.driversPerTeam > 1 && (
          <Panel>
            <SmsTimeAttackTeamTable
              set={set}
              teams={teams}
              tournamentId={tournamentId}
            />
          </Panel>
        )}
        <Panel>
          <SmsTimeAttackDriverTable
            set={set}
            teams={teams}
            tournamentId={tournamentId}
          />
        </Panel>
      </>
    );
  }

  return (
    <>
      {set.format.driversPerTeam > 1 && (
        <Panel>
          <TimeAttackTeamTable
            set={set}
            teams={teams}
            tournamentId={tournamentId}
          />
        </Panel>
      )}
      <Panel>
        {/* todo - hardcoded */}
        <TimeAttackDriverTable
          set={set}
          teams={teams}
          tournamentId={tournamentId}
          groups={
            matchId === "1719666000000x001"
              ? [
                  { startPosition: 1, endPosition: 6, color: "mediumseagreen" },
                  { startPosition: 7, endPosition: 22, color: "steelblue" },
                ]
              : undefined
          }
        />
      </Panel>
    </>
  );
};
